import { computed, observable, toJS, runInAction } from 'mobx';
import API from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';

interface openingHours {
  openTime: string;
  closeTime: string;
  closed: boolean;
}

export interface SpecialHours extends openingHours {
  startDate: string;
  endDate: string;
}

export interface BusinessHours extends openingHours {
  startDay: string;
  endDay: string;
}

interface Translations {
  et: string;
  ru: string;
  [key: string]: string;
}

export interface Store {
  name: string;
  googleMapsLink: string;
  streetAddress: Translations;
  locationDescription: Translations;
  additionalDescription: Translations;
  businessHours: BusinessHours[];
  specialHours: SpecialHours[];
}

class StoresStore {
  @observable private accessor storesByCityName: Map<string, Store[]> = new Map();

  private NUMBER_OF_CITY_COLUMNS: number = 4;

  @computed
  public get storesByCity(): Map<string, Store[]> {
    return toJS(this.storesByCityName);
  }

  @computed
  public get cityNamesList(): string[][] {
    if (!this.storesByCity.size) {
      return [];
    }
    const cityNames = Array.from(this.storesByCity.keys()).sort();
    const numberOfCities = Math.ceil(cityNames.length / this.NUMBER_OF_CITY_COLUMNS);
    const cityNamesList: string[][] = [];

    for (let i = 0; i < cityNames.length; i += numberOfCities) {
      cityNamesList.push(cityNames.slice(i, i + numberOfCities));
    }
    return cityNamesList;
  }

  public fetchStores = async () => {
    try {
      const { data } = await API.get('/stores');
      runInAction(() => (this.storesByCityName = new Map(Object.entries(data))));
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
    }
  };
}

export default StoresStore;
